function mountMgmAds() {
  const { mgmZoneId, dabuSourceUrl, dabuPlacementId } = this.dataset;
  const category = dabuSourceUrl.split('/')[3];
  let mgmUrl = '';
  let imgUrl = '';
  switch (category) {
    case 'poker':
      if (mgmZoneId === '1670856') {
        mgmUrl = new URL('https://poker.betmgm.com');
      } else {
        mgmUrl = new URL('https://playmgmpoker.onelink.me/9kcr/affiliates');
      }
      mgmUrl.searchParams.set('wm', '7081136');
      break;
    case 'sports':
      mgmUrl = new URL('https://promo.nj.betmgm.com/en/promo/geolocator');
      mgmUrl.searchParams.set('orh', 'promo.betmgm.com');
      mgmUrl.searchParams.set('wm', '7081134');
      break;
    case 'casino':
      mgmUrl = new URL('https://promo.betmgm.com/en/promo/casino/deposit-welcome-offer');
      mgmUrl.searchParams.set('wm', '7081133');
      break;
    default:
      this.logger.debug('no category found');
  }
  if (mgmUrl && mgmZoneId) {
    mgmUrl.searchParams.set('zoneId', mgmZoneId);
    imgUrl = new URL('https://mediaserver.betmgmpartners.com/renderBanner.do');
    imgUrl.searchParams.set('zoneId', mgmZoneId);
    this.logger.debug('MGM path:', mgmUrl);
    const mountingNode = this.doc.getElementById(dabuPlacementId);
    if (mountingNode) {
      const attribution = this.doc.createElement('a');

      attribution.href = mgmUrl;
      attribution.rel = 'nofollow';

      const image = this.doc.createElement('img');
      image.src = `${imgUrl}&t=i&v=1`;
      attribution.append(image);

      mountingNode.append(attribution);

      // Attach click listeners
      const handleClick = this.generateClickHandler(dabuPlacementId, mountingNode, 0);
      attribution.addEventListener('click', handleClick, false);

      // Page-in-view GA event logging
      this.watchForView(dabuPlacementId);

      const { logger } = this.adPlacements[dabuPlacementId];
      const adPlacementsArr = Object.keys(this.adPlacements);
      if (adPlacementsArr.length === 1 || adPlacementsArr[1] === dabuPlacementId) {
        const {
          adResultsDisplayedTop,
          adResultsDisplayedBottom,
          adResultsDisplayed,
        } = this.getNoOfAdBlockResults('a');

        // Ad click event GA event logging
        const payload = logger.getContentRenderedPayload({
          eventType: 'ContentRendered',
          adResultsDisplayedTop,
          adResultsDisplayedBottom,
          adResultsDisplayed,
        });
        logger.logEvent(payload);
      }
    } else {
      this.logger.error(new Error('Mounting node not found'));
    }
  }
}

export default mountMgmAds;
